// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterBar-cls1_Xot","cls2":"FilterBar-cls2_YR7 FilterBar-cls1_Xot"};